export default __webpack_public_path__ + "static/media/mobile-link.0e9f6adb.webp";